import React from 'react';
import { useLocation } from 'react-router-dom';
import UnifiedState from './UnifiedState';
import { reportClientError } from '../services/clientErrorService';
import './AppErrorBoundary.css';

export class AppErrorBoundaryCore extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, details) {
    console.error('[AppErrorBoundary] Unhandled render error', error, details);
    reportClientError(error, {
      source: 'react',
      componentStack: details?.componentStack || '',
    });
  }

  componentDidUpdate(previousProps) {
    if (previousProps.resetKey !== this.props.resetKey && this.state.error) {
      // Resetting after navigation lets a broken route fail independently.
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="app-error-boundary">
        <div className="app-error-boundary__card">
          <p className="app-error-boundary__eyebrow">Unified Workforce</p>
          <UnifiedState
            type="error"
            title="This page could not be displayed"
            message="Your data is safe. Reload the page to restore the workspace."
            actionLabel="Reload page"
            onAction={() => window.location.reload()}
          />
          <button
            type="button"
            className="app-error-boundary__home"
            onClick={() => { window.location.href = '/'; }}
          >
            Return to workspace
          </button>
        </div>
      </main>
    );
  }
}

const AppErrorBoundary = ({ children }) => {
  const location = useLocation();
  return (
    <AppErrorBoundaryCore resetKey={`${location.pathname}${location.search}`}>
      {children}
    </AppErrorBoundaryCore>
  );
};

export default AppErrorBoundary;
